module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hyra-ut-bostadsratt"
    }
  }, [_c('h1', [_vm._v("Hyra ut bostadsrätt")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("Vad får man ta i hyra")]), _vm._v(" "), _c('p', [_vm._v("När du hyr ut en bostadsrätt har du rätt att ta ut en "), _c('router-link', {
    attrs: {
      "to": '/kostnadsbaserad-hyra'
    }
  }, [_vm._v("kostnadsbaserad hyra")])], 1), _vm._v(" "), _c('h2', [_vm._v("Länkar")]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Det finns några viktiga faktorer att tänka på om du skall hyra ut en bostadsrätt i andrahand. Hyran du får ta ut regleras av "), _c('strong', [_vm._v("privatuthyrningslagen")]), _vm._v(", men detta gäller bara den första bostadsrätten du hyr ut, om du hyr ut två bostadsrätter.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Om du hyr ut "), _c('strong', [_vm._v("fler än två")]), _vm._v(" bostadsrätter så är det istället "), _c('strong', [_vm._v("hyreslagen")]), _vm._v(" som reglerar vad du får ta i hyra.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "http://www.notisum.se/Pub/Doc.aspx?url=/rnp/sls/lag/20120978.htm"
    }
  }, [_vm._v("Privatuthyrningslagen")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61a156d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bostadsratt.vue
// module id = 19
// module chunks = 0